/* @flow */
import React from 'react';
import { Creatable } from 'react-select';
import classnames from 'classnames/bind';
import styled from 'styled-components';
import 'react-select/dist/react-select.css';

import s from './TagSelect.styl';
const cx = classnames.bind(s);

const TAG_SELECT_OPTION_CLASS_NAME = 'tag-select-option';

type TagSelectProps = {
  value?: any,
  inline: boolean,
  options: Array<any>,
  className?: string,
  onChange: Function,
  cyId?: string,
};

const StyledCreatable = styled(Creatable)`
  && {
    .Select-control {
      background-color: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
    }

    .${TAG_SELECT_OPTION_CLASS_NAME} {
      background-color: ${({ theme }) => theme.ThemeColors.SURFACE.hex};
      color: ${({ theme }) => theme.ThemeColors.TEXT.hex};

      &:hover {
        background-color: ${({ theme }) => theme.ThemeColors.SURFACE_LIGHTER.hex};
      }
    }
  }
`;

export class TagSelect extends React.Component {

  static defaultProps = {
    inline: false,
  };

  props: TagSelectProps;

  /* Continue to update state with new options as options change
   * (e.g. by being selected) */
  componentWillReceiveProps({ options }: Object) {
    this.setState({ options });
  }

  // NOTE: Very odd, but it seems the Creatable component requires the options
  // array passed to it to be mutable. Of course, it is a mutable array,
  // however, the parent component in our codebase usually renders using an
  // immutable object it converts into an array. I beleive this is why we
  // couldn't simply pass in our own arrays and have it work. As such, options
  // is kept in state so that the Creatable component can add to it as
  // necessary.
  state = { options: this.props.options };

  render() {
    const { onChange, className, value, inline, cyId, ...props } = this.props;
    return (
      <StyledCreatable
        {...props}
        data-cy={cyId}
        className={cx(className, { inline })}
        value={value}
        onChange={onChange}
        noResultsText='No tags found'
        options={this.state.options}
        optionClassName={TAG_SELECT_OPTION_CLASS_NAME}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./web_modules/trustar/components/TagSelect.js